export default {
  SET_FEATURE_CATEGORIES (state, feature_categories) {
    state.feature_categories = feature_categories
  },
  REMOVE_RECORD (state, itemId) {
    const featureCategoryIndex = state.feature_categories.findIndex((u) => u.id === itemId)
    state.feature_categories.splice(featureCategoryIndex, 1)
  }
}
